$(function () {
  $('.js-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    asNavFor: '.js-sliderNav'
  });
  $('.js-sliderNav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider',
    focusOnSelect: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="material-icons">navigate_before</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="material-icons">navigate_next</span></button>',
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      }
    }]
  });
  // remove active class from all thumbnail slides
  $('.js-sliderNav .slick-slide').removeClass('slick-active');

  // set active class to first thumbnail slides
  $('.js-sliderNav .slick-slide:not(.slick-cloned)').eq(0).addClass('slick-active');

  // On before slide change match active thumbnail to current slide
  $('.js-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.js-sliderNav .slick-slide').removeClass('slick-active');
    $('.js-sliderNav .slick-slide:not(.slick-cloned)').eq(mySlideNumber).addClass('slick-active');
  });

  $('.js-kamomeSlider').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="material-icons">navigate_before</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="material-icons">navigate_next</span></button>',
    autoplaySpeed: 4000,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
});
